"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLayoutFeature = void 0;
var _topArea = require("@ori/top-area");
var _ChatsLoader = require("../../components/ChatsLoader");
var _LanguageSwitcher = require("../../components/LanguageSwitcher");
/**
 * Represents a collection of features available in the DefaultLayout component.
 *
 * This object combines various features such as `ChatFeature`, `TopAreaFeature`,
 * `LanguageSwitcherFeature`, and `LoginFeature`.
 *
 * @remarks
 * The features included in this object are essential components of the DefaultLayout
 * component, providing functionality for chat, top area, language switcher, and login.
 */
const DefaultLayoutFeature = exports.DefaultLayoutFeature = {
  ..._ChatsLoader.ChatFeature,
  ..._topArea.TopAreaFeature,
  ..._LanguageSwitcher.LanguageSwitcherFeature,
  /** Use the Share and Earn functionality internationally between tenants */
  InternationalShareAndEarn: 'BE776F8A-5B13-442B-BBE9-58DD2C7C5F22'
};
